import React from 'react'
import { motion, AnimatePresence } from 'framer-motion'

const MapPoint = (props) => {
  const { color, name, isReport, disableAnimation = false } = props
  if (props.modern) {
    return (
      <button
        type="button"
        className={`report-map-pin ${props.selected ? 'report-map-pin--selected' : ''}`}
        style={{ '--pin-color': props.pinColor || (isReport ? '#3cbf47' : '#ef5350') }}
        aria-label={name}
        aria-pressed={Boolean(props.selected)}
        onClick={props.onClick}
      >
        <span className="report-map-pin__halo" />
        <span className="report-map-pin__head">
          <span />
        </span>
        <span className="report-map-pin__label">{props.label || (isReport ? 'Cliente' : 'Actividad')}</span>
      </button>
    )
  }
  return (
    <div>
      {isReport && (
        <div>
          <div
            className={`pin-client${disableAnimation ? '' : ' bounce'}`}
            style={{ backgroundColor: color, cursor: 'pointer' }}
            title={name}
          />
          {!disableAnimation && <div className="dot" />}
          <span>
            {!disableAnimation && (
              <AnimatePresence mode="wait">
                {(props.$hover || props.hover) && <MarkerClientLocation {...props} />}
              </AnimatePresence>
            )}
            {disableAnimation ? (
              <span className="marker-indicator" />
            ) : (
              <motion.span whileTap={{ scale: 1.1 }} className="marker-indicator" />
            )}
          </span>
        </div>
      )}
      {!isReport && (
        <div>
          <div
            className={`pin-activity${disableAnimation ? '' : ' bounce'}`}
            style={{ backgroundColor: color, cursor: 'pointer' }}
            title={name}
          />
          {!disableAnimation && <div className="pulse" />}
          <span>
            {!disableAnimation && (
              <AnimatePresence mode="wait">
                {(props.$hover || props.hover) && <MarkerActivityLocation ubicationName={name} />}
              </AnimatePresence>
            )}
            {disableAnimation ? (
              <span className="marker-indicator" />
            ) : (
              <motion.span whileTap={{ scale: 1.1 }} className="marker-indicator" />
            )}
          </span>
        </div>
      )}
    </div>
  )
}

const markerVariants = {
  hidden: {
    opacity: 0,
    scale: 0,
    transformOrigin: 'center center'
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      when: 'beforeChildren',
      staggerChildren: 0.1,
      duration: 0.1,
      delay: 0.2
    }
  },
  exit: {
    opacity: 0,
    scale: 0,
    transformOrigin: 'center center',
    transition: {
      when: 'afterChildren',
      staggerChildren: 0.05,
      staggerDirection: -1,
      delay: 0.1
    }
  }
}

export function MarkerActivityLocation(props) {
  return (
    <motion.div
      variants={markerVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="sale-marker-info-wrapper"
    >
      <motion.div className="place-marker-redirect-link">{props.ubicationName}</motion.div>
    </motion.div>
  )
}

export function MarkerClientLocation() {
  return (
    <motion.div
      variants={markerVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="sale-marker-info-wrapper"
    >
      <motion.div className="place-marker-redirect-link">Ubicación del cliente</motion.div>
    </motion.div>
  )
}

export default MapPoint
